export const AssetListResultColumnsModule = [
  {
    label: 'status',
    property: 'isActive',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Customer Number',
    property: 'customerNumber',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Asset Type',
    isVisible: true,
    width: 20,
    template: {
      type: 'content',
      property: 'assetType'
    }
  },
  {
    label: 'Make',
    property: 'make',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Model',
    property: 'model',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Serial Number',
    width: 20,
    cellClass: 'cellLink',
    isVisible: true,
    template: {
      type: 'content',
      property: 'serialNumber'
    }
  },
  {
    label: 'Asset Tag',
    property: 'tag',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Customer Asset Number',
    property: 'customerAssetNumber',
    type: 'string',
    isVisible: true,
    width: 20
  },
  {
    label: 'Created Date',
    isVisible: true,
    width: 20,
    template: {
      type: 'content',
      property: 'createdDate'
    }
  },
  {
    label: 'Updated Date',
    isVisible: true,
    width: 20,
    template: {
      type: 'content',
      property: 'updatedDate'
    }
  }
];
